import React from "react";
import { Button } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { MdFileDownload, MdLocalPrintshop, MdSmartphone } from "react-icons/md";
import { useSelector } from "react-redux";
import { STATE_CULTURE } from "../../Actions/cookiesActions";

const useStyles = createStyles((theme) => ({
  actions: {
    marginTop: "1rem",
    width: "100%",
    display: "flex",
    flexWrap: "nowrap",
    gap: "1rem",
    a: {
      maxWidth: "280px",
      width: "100%",
    },
    button: {
      maxWidth: "280px",
      width: "100%",
    },

    "@media screen and (max-width: 768px)": {
      flexWrap: "wrap",
      a: {
        maxWidth: "100%",
      },
      button: {
        maxWidth: "100%",
      },
    },
  },
  appleWalletButton: {
    maxWidth: "8rem !important",
    "@media screen and (max-width: 768px)": {
      width: "100% !important",
      maxWidth: "12rem !important",
    },

    img: {
      width: "100%",
    },
  },
}));
const ReceiptActions = ({
  hideMobileTicket,
  language,
  giftCertificates,
  ticketsDownloadUri,
  barcodeUri,
  saleId,
  walletUri,
}) => {
  const { config, culture } = useSelector((state) => ({
    config: state.config,
    culture: state.cookies[STATE_CULTURE],
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.actions}>
      <Button
        variant="primary"
        className="primaryButton iconButton"
        onClick={() => window.print()}
        leftSection={<MdLocalPrintshop />}
        aria-label={language.PrintReceipt}
      >
        {language.Receipt}
      </Button>
      {giftCertificates.map((el, i) => (
        <Button
          component="a"
          variant="primary"
          className="primaryButton"
          key={i}
          href={el.uri}
          target="_blank"
        >
          {el.article.name}
        </Button>
      ))}
      {ticketsDownloadUri.length > 0 && (
        <Button
          component="a"
          variant="primary"
          className="primaryButton iconButton"
          href={ticketsDownloadUri}
          leftSection={<MdFileDownload />}
        >
          {language.Receipt_Download_Tickets}
        </Button>
      )}
      {!hideMobileTicket && barcodeUri && (
        <Button
          component="a"
          variant="primary"
          className="primaryButton iconButton"
          leftSection={<MdSmartphone />}
          href={barcodeUri}
        >
          {language.ShowMobileTicket}
        </Button>
      )}

      {walletUri && (
        <a
          className={classes.appleWalletButton}
          target="_blank"
          rel="noreferrer"
          href={walletUri}
          aria-label="Lägg till i Apple Wallet"
        >
          <img
            src={`${config?.self}/images/apple-wallet-${culture}.svg`}
            alt="Apple Wallet"
          />
        </a>
      )}
    </div>
  );
};

export default ReceiptActions;
